import { useToast as useMolyToast } from '@bfe/moly';

export const useToast = () => {
  const { toast, EToastType } = useMolyToast();

  const toastWarn = (text: string) => {
    toast({
      iconType: EToastType.WARN,
      title: text,
    });
  };

  const toastSuccess = (text: string) => {
    toast({
      iconType: EToastType.SUCCESS,
      title: text,
    });
  };

  const toastFail = (text: string) => {
    toast({
      iconType: EToastType.FAIL,
      title: text,
    });
  };

  const toastInfo = (text: string) => {
    toast({
      iconType: EToastType.INFO,
      title: text,
    });
  };

  return {
    toastWarn,
    toastSuccess,
    toastFail,
    toastInfo,
  };
};
